import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './ProgressBar.styl';

class ProgressBar extends Component {
    getColor = (percentage) => {
        const { colorThreshold } = this.props;
        if (!colorThreshold || colorThreshold.length !== 2 || percentage < colorThreshold[0]) return 'green';
        if (percentage >= colorThreshold[0] && percentage < colorThreshold[1]) return 'orange';
        return 'red';
    };

    getExtremitiesText = (text) => <span>{text}</span>;

    render() {
        const { percentage, leftText, rightText, description, colorThreshold } = this.props;
        return (
            <div className="progress">
                {description && <div className="progress__legend">{description}</div>}
                <div className="progress__wrapper">
                    {leftText && this.getExtremitiesText(leftText)}
                    <div
                        className={classNames('progress__bar', {
                            [`progress__bar--${this.getColor(percentage)}`]: !!colorThreshold,
                        })}
                    >
                        <div className="progress__gauge" style={{ width: `${percentage}%` }} />
                    </div>
                    {rightText && this.getExtremitiesText(rightText)}
                </div>
            </div>
        );
    }
}

function withinHundred(isRequired) {
    return function fn(props, propName, componentName = 'ANONYMOUS') {
        const value = props[propName];
        if (value === null && isRequired) {
            return new Error(`Required ${propName} was not specified in ${componentName}.`);
        }
        if (typeof value === 'number') {
            return value >= 0 && value <= 100
                ? null
                : new Error(`${propName} in ${componentName} is not within 0 to 100`);
        }
        return new Error(`${propName} in ${componentName} is not a number`);
    };
}

const customPropType = withinHundred(false);
customPropType.isRequired = withinHundred(true);

ProgressBar.defaultProps = {
    colorThreshold: null,
    leftText: '',
    rightText: '',
    description: '',
};

ProgressBar.propTypes = {
    percentage: customPropType.isRequired,
    colorThreshold: PropTypes.arrayOf(PropTypes.number),
    leftText: PropTypes.string,
    rightText: PropTypes.string,
    description: PropTypes.string,
};

export default ProgressBar;
